export * from "./array-tool";
export * from "./linq";
export * from './string-tool';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/core/tools/index.ts